<template>
  <div class="flex items-center px-3 py-4 text-sm text_color">
    <span v-if="!row?.bound_app" class="secondary_color">—</span>
    <span
      v-else
      :id="`external_domain_bound_app_${row?.id}`"
      class="truncate"
      :title="row.bound_app.name || row.bound_app.slug"
    >
      {{ row.bound_app.name || row.bound_app.slug }}
    </span>
  </div>
</template>

<script setup>
defineProps({
  value: { type: String, default: "" },
  row: { type: Object, default: () => ({}) },
});
</script>
